import { InjectionToken, Signal } from '@angular/core';

/**
 * Injection token that badge directive will read from the nearest permission directive.
 * The value is a Signal<'alpha'|'beta'|null>.
 */
export const PERMISSION_STATUS = new InjectionToken<Signal<
  string | undefined
> | null>('PERMISSION_STATUS');
